<template>
    <div class="fixed-pop">
        <div class="fixed-pop-content">
            <div class="PullDownClose">
                <div class="top-list">
                    <div class="image_empty"  v-if="imageSrc===''"/>
                    <el-image v-else :src="imageSrc" fit="cover"/>

                    <div class="right">
                        <div class="name">{{itemTitle}}</div>
                        <div class="red fee">${{price}}</div>
                        <div class="num" v-show="getBuyLimit()>0">剩餘數量：{{getBuyLimit()}}</div>
                    </div>
                </div>
                <div class="content">
                    <div class="mt-4">
                        <h6>選擇日期</h6>
                        <el-select v-model="selectDate" placeholder="請選擇日期" class="w-100">
                            <el-option
                                    v-for="(item, index) in days"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.stageStartAt"/>
                        </el-select>
                    </div>

                    <div class="mt-4" v-if="isShowTimeSelector">
                        <h6>選擇時段</h6>
                        <el-radio-group v-model="selectTime" class="BorderType">
                            <el-radio v-for="(timeItem, index) in times" :label="timeItem.stageStartTime" :key="index" border/>
                        </el-radio-group>
                    </div>

                    <div class="d-flex mt-4 addNum">
                        <h6 class="mr-2">數量</h6>
                        <NumberController :params="{ default: buyAmount, min: 0,}" @triggerEvent="numberControllerEvent" :size="'mini'"/>
                        <span class="num ml-2" v-show="getBuyLimit()>0">剩餘數量：{{getBuyLimit()}}</span>
                    </div>
                </div>

                <div class="text-center footer-button">

                    <!--todo 點選擇日期場次進來的-->
                    <el-button round @click="onClickAddCart" v-if="buyStyle===0">加入購物車</el-button>
                    <el-button round type="warning" @click="onClickBuy" v-if="buyStyle===0">直接購買</el-button>

                    <!--todo 直接點加入購物車進來的-->
                    <el-button round type="warning" @click="onClickAddCart" v-if="buyStyle===1">確定</el-button>

                    <!--todo 直接點直接購買進來的-->
                    <el-button round type="warning" @click="onClickBuy" v-if="buyStyle===2">確定</el-button>
                </div>

            </div>

            <div class="fixed-pop-closed" @click="cancel()"/>
        </div>
    </div>

</template>
<script>
    import NumberController from '../../../components/NumberController'
    import Cart from "@/util/cart";

    const weekArr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]

    export default {
        name: "SelectDate",
        props: {
            //點選進來的方式  0點日期場次 1點加入購物車 2點直接購買
            imageSrc:{type:String, default: ''},
            buyStyle:{type:Number, default: 0},
            dateSetting: Array,             //訂位時間設定，格式說明在下方
            defaultSelectDate:{type:String, default: ''},
            defaultSelectTime:{type:String, default: ''},
            defaultBuyAmount:{type:Number, default: 0},
            price:{type:Number, default: 0},
        },
        components: {
            NumberController,
        },
        watch: {
            "dateSetting": function () {
                this.updateDateSetting();
            },
            "selectDate": function () {

                this.updateTimeSetting(this.selectDate);
                this.updateBuyLimitForDate(this.selectDate);
                this.$emit('selectDateChanged', this.selectDate);
            },
            "selectTime": function () {
                this.updateBuyLimitForTime(this.selectTime);
                this.$emit('selectTimeChanged', this.selectTime);
            },
        },
        data() {
            return {

                //假資料可刪
                days:[
                    // {value: '03/12 (三)',label: '2024 年 03 月 12 日 (三)'},
                    // {value: '03/18 - 03/31',label: '2024/03/18 - 2024/03/31'},
                ],
                times: [],
                itemTitle: '',
                selectDate: '',             //選定的日期
                selectTime: '',             //選定的時間
                maxAmount: 0,
                buyAmount: 0,
                isShowTimeSelector: false,  //是否顯示時段選擇
                numberControllerParams: {
                    default: 1,
                    min: 1,
                },
            }
        },
        mounted() {
            this.updateDateSetting();
            this.selectDate = this.defaultSelectDate ;
            this.selectTime = this.defaultSelectTime ;
            this.buyAmount = this.defaultBuyAmount ;
        },
        methods: {

            /** 更新訂位日期設定() */
            updateDateSetting: function () {
                //dateSetting 格式
                // [
                //     {
                //         "id": 1,                         //ID (前端自訂的)
                //         "stageStartAt": "2024-04-11",
                //         "stageEndAt": "2024-04-11",
                //         "intervalType": 1,               //intervalType：1(小時) 2(分鐘) 3(整日) 4(整個區間)
                //         "detailTime": [                  //各時段的資料，intervalType為1、2時才有這欄位
                //             {
                //                 "intervalUnit": 2,       //該場次有多長， 時間單位看上層intervalType
                //                 "sendAmount": 0,
                //                 "sendMax": 200,
                //                 "setAmount": 0,
                //                 "shoppingSoldCount": 0,
                //                 "stageEndTime": "10:00",         //時段的結束時間
                //                 "stageStartTime": "08:00",       //時段的開始時間
                //                 "startBeforeMinuteValid": 15,
                //                 "parentId": 1                    //上層的 id
                //             }, ...
                //         ]
                //     }, ...
                // ]

                let self = this;
                if (this.$public.notNull(this.dateSetting) && this.dateSetting.length>0) {
                    this.days = [];

                    //日期整理排序
                    this.dateSetting.forEach(function (item1) {
                        //存起可訂位日期
                        self.days.tmz_load_push(item1);
                    });

                    //排序
                    //  array.sort(function(o1,o2){
                    //     if (sort_o1_before_o2)    return -1;
                    //     else if(sort_o1_after_o2) return  1;
                    //     else                      return  0;
                    //  });
                    this.days.sort(function(a, b){
                        // Turn your strings into dates, and then subtract them
                        // to get a value that is either negative, positive, or zero.
                        return new Date(a.stageStartAt) - new Date(b.stageStartAt);
                    });
                }
            },

            /** 更新訂位時段 ( value: yyyy-MM-dd )*/
            updateTimeSetting(value) {
                if (!value)
                    return;

                let day = new Date(Date.parse(value.replace(/-/g, '/')));
                const getWeek = day.getDay();
                this.week = getWeek;
                this.weekName = weekArr[getWeek];
                this.isLoading = true;

                if (this.$public.notNull(this.days) && this.days.length>0) {
                    //日期整理排序
                    let self = this;
                    let BreakException = {};
                    try {
                        self.days.forEach(function (item) {
                            if (item.stageStartAt === value) {

                                //更新最大可購買量
                                self.maxAmount = item.setAmount - item.shoppingSoldCount;

                                if (item.intervalType === 1 || item.intervalType === 2) {
                                    //可選擇的日期的陣列
                                    self.times = item.detailTime;
                                    self.isShowTimeSelector = true;

                                } else {
                                    self.isShowTimeSelector = false;
                                }
                                throw BreakException;
                            }
                        });
                    } catch (e) {
                        if (e !== BreakException) throw e;
                    }
                }
            },

            /** 更新最大可購買量(整天) */
            updateBuyLimitForDate: function(selectDate) {
                let setAmount = 0;
                let shoppingSoldCount = 0;
                //日期整理排序
                if (this.$public.notNull(this.days)) {

                    let BreakException = {};
                    try {
                        this.days.forEach(function (item) {
                            //存起可訂位日期
                            if (selectDate === item.stageStartAt) {
                                if (item.intervalType === 3 || item.intervalType === 4 ) {
                                    setAmount = item.setAmount;
                                    shoppingSoldCount = item.shoppingSoldCount;
                                }
                                throw BreakException;
                            }
                        });
                    } catch (e) {
                        if (e !== BreakException) throw e;
                    }
                }

                this.maxAmount = setAmount - shoppingSoldCount;
            },

            /** 更新最大可購買量(時段類) */
            updateBuyLimitForTime: function(selectTime) {
                let setAmount = 0;
                let shoppingSoldCount = 0;
                //日期整理排序
                if (this.$public.notNull(this.times)) {

                    let BreakException = {};
                    try {
                        this.times.forEach(function (item) {
                            //存起可訂位日期
                            if (selectTime === item.stageStartTime) {
                                setAmount = item.setAmount;
                                shoppingSoldCount = item.shoppingSoldCount;
                                throw BreakException;
                            }
                        });
                    } catch (e) {
                        if (e !== BreakException) throw e;
                    }
                }

                this.maxAmount = setAmount - shoppingSoldCount;
            },

            /** 取得最大可購買量 */
            getBuyLimit: function() {
                return this.maxAmount - this.buyAmount;
            },

            //點黑底處關閉
            cancel() {
                this.$emit('close','close');
            },

            //加入購物車
            onClickAddCart(){
                this.$emit('close','AddCart');
            },

            //直接購買
            onClickBuy(){
                this.$emit('close','Buy');
            },

            numberControllerEvent(args) {
                if (args.number >= 0) {
                    this.addAmount(args.number);
                }
                this.$emit('onBuyAmountChanged', this.buyAmount);
            },

            /** 數量變動 */
            addAmount: function(buyAmount) {
                this.buyAmount = buyAmount;
                if (this.buyAmount >= 99) {
                    this.buyAmount = 99;
                } else if (this.buyAmount <= 0) {
                    this.buyAmount = 0;
                }
            },
        }
    }
</script>

<style lang="less" scoped>
    //固定下方捲動頁
    .fixed-pop {
        @media(min-width: 1024px){
            display: block !important;
            margin-left: inherit;
        }
        .fixed-pop-content {
            @media(max-width: 1023px){
                position: fixed;
                width: 100%;
                max-width: 1024px;
                bottom: 0;
                z-index: 999;
                left: 0;
            }
            @media(min-width: 1024px){
                margin-top: -40px;
                position: relative;
                width: inherit;
                z-index: 1;
            }
        }
        //關閉區塊
        .fixed-pop-closed {
            @media(max-width: 1023px){
                position: fixed;
                display: block;
                top: 0;
                width: 100%;
                left: 0;
                height: 100%;
                z-index: 110;
                background: rgba(0,0,0,.3);
                max-width: 1024px;
            }

            @media(min-width: 1024px){
                display: none;
            }
        }
        .PullDownClose {
            &::before {
                display: none;
            }
            @media (max-width: 1023px) {
                background: #fff;
                padding: 20px 20px calc(20px + env(safe-area-inset-bottom));
                min-height: 250px;
                max-height: 78vh;
                position: relative;
                z-index: 111;
                animation-name: slideIn;
                animation-duration: 0.5s;
                display: flex;
                flex-direction: column;
                overflow: hidden;
                border-radius: 16px 16px 0 0;
                box-shadow: 0 -3px 4px rgba(0, 0, 0, .15);
            }
            @media (min-width: 1024px) {
                box-shadow: none;
                background: none;
                animation: none;
            }
        }
        @keyframes slideIn {
            from {
                transform: translateY(100vh);
            }
            to {
                transform: translateY(0);
            }
        }
    }
    //小縮圖照片＋價錢
    .top-list{
        @media(max-width: 1023px){
            display: flex;
            .el-image , .image_empty{
                flex: 0 0 80px;
                height: 80px;
                border-radius: 10px;
                margin-right: 8px;
                /deep/img{
                    width: 100% !important;
                }
            }
            .num {
                font-size: 12px;
            }
            .name {
                line-height: 18px;
                color: #333;
                word-break: break-all;
            }
            .fee {
                font-weight: 500;
                margin-top: 5px;
            }
        }
        @media(min-width: 1024px){
            display: none;
        }
    }
    .content{
        /deep/.amount.mini::before{
            display: none;
        }
        @media(max-width: 1023px){
            flex: 1;
            overflow-y: auto;
        }
        //數量
        .addNum{
            align-items: center;
            h6{
                margin: 0;
                @media(max-width: 1023px){
                    flex: 1;
                }
            }
            .num{
                @media(max-width: 1023px){
                    display: none;
                }
                @media(min-width: 1024px){
                    font-size: 14px;
                }
            }
        }

    }
    .footer-button{
        @media(min-width: 1024px){
            margin: 35px 0;
        }
    }
</style>
